export * from './post-vorlage.component';
export * from './post-vorlage.component.module';